import React, { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"

import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import { Bar } from '@ant-design/plots';
import "../scss/report.scss"
import { Table, Spin, Button } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../../utils/storage.service";
import Loading from "../../customer/Loading";
import { Tooltip } from "antd";

const ReportDoanhSoThuanKtvTvvDetailCat = (props) => {
    console.log(props.userId)
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    // useEffect(() => {
    //     setTitle("Theo nhân viên đặt lịch")
    // }, [])

 
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        { dataIndex: 'user_name', title: 'Nhân viên', width: 150, fixed : 'left' },
        // { field: 'totalOrder', headerName: 'Số đơn hàng', type: "number", width: 160, styles: { color: "red" } },
        {
            dataIndex: 'tong_thuan',
            title: <Tooltip className="show-tooltip" title='Tổng tiền khách hàng phải thanh toán cho hoá đơn kỹ thuật viên đã tư vấn cho khách hàng trong khoảng thơi gian đã chọn. Không quan tâm khách đã thanh toán hay chưa. Nhận những đơn upsale, chuyển đổi cọc, hoàn thành, nâng cấp. Không nhận đơn nạp tiền.'> Doanh số thuần <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            width: 160,
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'paidThuan',
            title: 'Thực thu thuần',
            title: <Tooltip className="show-tooltip" title='Tổng tiền khách hàng đã thanh toán cho hoá đơn kỹ thuật viên đã tư vấn trong khoảng thơi gian đã chọn. Nhận những đơn upsale, chuyển đổi cọc, hoàn thành, nâng cấp. Không nhận đơn nạp tiền.'> Thực thu thuần <i className="fas fa-info-circle"></i></Tooltip>,

            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.total_paid) - Number(b.total_paid),
                multiple: 1,
            },
        },
        {
            title: 'Triệt lông',
            align: "start",
            // width: 150 ,
            render: (data) => {
                return (
                    <div>
                        <p className="text1">Doanh số thuần: {convertCurrency(data.triet_thuan)}</p>
                        <p className="text3">Thực thu thuần: {convertCurrency(data.triet_thu_thuan)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countDa',
            title: 'Da',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Doanh số thuần: {convertCurrency(data.da_thuan)}</p>
                        <p className="text3">Thực thu thuần: {convertCurrency(data.da_thu_thuan)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'paidTriet',
            title: 'Chăm sóc body',
            align: "start",
            // width: 150 ,
            render: (data) => {
                return (
                    <div>
                        <p className="text1">Doanh số thuần: {convertCurrency(data.body_thuan)}</p>
                        <p className="text3">Thực thu thuần: {convertCurrency(data.body_thu_thuan)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Mỹ phẩm',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Doanh số thuần: {convertCurrency(data.my_pham_thuan)}</p>
                        <p className="text3">Thực thu thuần: {convertCurrency(data.my_pham_thu_thuan)}</p>
                    </div>
                )
            },
        },
        {
            title: 'Đầu triệt',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Doanh số thuần: {convertCurrency(data.dau_triet_thuan)}</p>
                        <p className="text3">Thực thu thuần: {convertCurrency(data.dau_triet_thu_thuan)}</p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Gội đầu',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Doanh số thuần: {convertCurrency(data.goi_thuan)}</p>
                        <p className="text3">Thực thu thuần: {convertCurrency(data.goi_thuan)}</p>
                        {/* <p className="text3">AOV: {convertCurrency(data.aovKhac)}</p> */}
                    </div>
                )
            },
        },
    ];

    const handelExportUser = () => {

    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

  
    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            {/* <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button> */}
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    // scroll={{ x: 'calc(700px + 50%)', y: 600 }}
                    scroll={{ x: columns.length*230, y: 600 }}
                    onChange={handleChange}
                    showSorterTooltip={{ title: '' }}
                    bordered
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
        </>
    )
}
export default ReportDoanhSoThuanKtvTvvDetailCat